import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import MongoDB from '../../homepage/header-banner/MongoDB';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import CloudconsultCp from '../../homepage/consult/cloudconsult-cp';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
// import { MuiGrid } from '@mui/material';
import CardBox from '../../container/Box/Components/CardBox';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;



function ClustercloudmongodbENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Private MongoDB Cluster - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for MongoDB")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>NoSQL Database Engine Supporting Replicas on Kubernetes Cluster</p>",
                                `<p class='typo-14'>Supports sharding by distributing data across Replica Sets for scalable storage.</p>
                                <p class='typo-14'>Relatively easy to operate, suitable for services that require high throughput and large capacity.</p>
                                <p class='typo-14'>Provides superior performance compared to traditional RDBMS systems.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Operates on high-performance Persistent Volumes with optimized I/O for maximum efficiency</p>",
                                `<p class='typo-14'>Runs on SSD-based PV volumes, with three replicas (containers/PODs) forming a single service unit.</p>
                                <p class='typo-14'>In case of hardware failures on worker nodes, service continues seamlessly on replica containers (PODs) on other nodes.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Automatically reassigns containers (PODs) to other worker nodes during hardware failures for uninterrupted operation</p>",
                                `<p class='typo-14'>Kubernetes MongoDB containers (PODs) are structured with 3 replica nodes per service unit.</p> 
                                <p class='typo-14'>Each replica container (POD) is distributed across multiple Kubernetes worker nodes.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Automatically scales out (autoscaling) to expand containers and distribute service load effectively</p>",
                                `<p class='typo-14'>Periodically adjusts (increments or decrements) the number of containers (PODs) based on CPU usage, memory, or other custom metrics.</p>
                                <p class='typo-14'>Enables service expansion without the need for additional hardware resources.</p>
                                <p class='typo-14'>Offers a cluster solution that efficiently distributes load and optimizes costs.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>{Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-cloud-mongodb/mongodb_cluster.svg")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        {/* <MongoDB /> */}
                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>

            <FooterEn />
        </Sysfont>

    );

};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ClustercloudmongodbENG;